MOBILE_WIDTH_TRESHOLD = 750;
$(document).ready(function() {

    $('.hero-block-prestige-hp-wrapper .slider-wrapper').not('.slick-initialized').each((k, v) => {
        if($(v).hasClass('single-slide')){
            $(v).slick({
                arrows: false,
                dots: false,
                infinite: false,
                autoplay: false,
                cssEase: 'linear',
                speed: 2000,
                autoplaySpeed: 5000,
                pauseOnHover: false,
                pauseOnFocus: false,
                adaptiveHeight: false,
                fade: false
            });
        }
        else{
            $(v).slick({
                arrows: false,
                dots: false,
                infinite: true,
                autoplay: true,
                cssEase: 'linear',
                speed: 2000,
                autoplaySpeed: 5000,
                pauseOnHover: false,
                pauseOnFocus: false,
                adaptiveHeight: false,
                fade: true
            });
        }
    });
    $('.hero-block-prestige-wrapper .slider-wrapper').not('.slick-initialized').each((k, v) => {
        if($(v).hasClass('single-slide')){
            $(v).slick({
                arrows: false,
                dots: false,
                infinite: false,
                autoplay: false,
                cssEase: 'linear',
                speed: 2000,
                autoplaySpeed: 5000,
                pauseOnHover: false,
                pauseOnFocus: false,
                adaptiveHeight: false,
                fade: false
            });
        }
        else{
            $(v).slick({
                arrows: false,
                dots: false,
                infinite: true,
                autoplay: true,
                cssEase: 'linear',
                speed: 2000,
                autoplaySpeed: 5000,
                pauseOnHover: false,
                pauseOnFocus: false,
                adaptiveHeight: false,
                fade: true
            });
        }
    });
    $('.bg-video-block-prestige-wrapper .slider-wrapper').not('.slick-initialized').each((k, v) => {
        if($(v).hasClass('single-slide')){
            $(v).slick({
                arrows: false,
                dots: false,
                infinite: false,
                autoplay: false,
                cssEase: 'linear',
                pauseOnHover: false,
                pauseOnFocus: false,
                adaptiveHeight: false,
                fade: false
            });
        }
        else {
            $(v).slick({
                arrows: false,
                dots: false,
                infinite: true,
                autoplay: true,
                cssEase: 'linear',
                speed: 2000,
                autoplaySpeed: 5000,
                pauseOnHover: false,
                pauseOnFocus: false,
                adaptiveHeight: false,
                fade: true
            });
        }
    });
    jQuery(document).on("click",".table-iframe",function(e)
    {
        e.preventDefault();

        var $live_res_guid          = jQuery(this).data('live-res-guid');
        var $designmynight_site_id  = jQuery(this).data('designmynight_site_id');
        if($designmynight_site_id)
        {
            var $live_res_iframe = $('#designmynight');
            $live_res_iframe.html('<script src="//widgets.designmynight.com/bookings-partner.min.js" dmn-booking-form="true" dmn-booking-form venue="'+$designmynight_site_id+'" google-tag-manager-code="GTM-K7S6PLS"></script>');
            jQuery('#table-book-designmynight').addClass('active');
        }
        else if ($live_res_guid)
        {
            var $live_res_iframe = $('#table-book-new .js-reframe > iframe');
            $live_res_iframe.attr('src', $live_res_iframe.attr('src') + '&siteId=' + $live_res_guid);
            jQuery('#table-book-new').addClass('active');
        }
        else{
            jQuery('#table-book-new').addClass('active');
        }
    });

    $('.hero').not('.slick-initialized').slickOLD({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: true,
        cssEase: 'linear',
        speed: 900,
        autoplaySpeed: 4000,
        pauseOnHover: false,
        pauseOnFocus: false,
        adaptiveHeight: false,
    });

    $('.pub-gallery').slickOLD({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        asNavFor: '.slider-nav'
    });

    $('.slider-nav').slickOLD({
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.pub-gallery',
        dots: false,
        arrows: false,
        centerMode: false,
        focusOnSelect: true
    });
    $('.offers_static_block').slickOLD({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: true,
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,

              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
        ]

    });

    if($('body').hasClass('premium'))
    {
        const gallery = $('.gallery-block > .images');

        if($('body').hasClass('prestige'))
        {
            $(gallery).slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                prevArrow: ".sliderPrev",
                nextArrow: ".sliderNext",
                dots: true,
                appendDots: '.block.gallery-block',
                infinite: true,
                autoplay: true,
                cssEase: 'linear',
                speed: 2000,
                autoplaySpeed: 5000,
                pauseOnHover: false,
                pauseOnFocus: false,
                adaptiveHeight: false,
                fade: true,
                responsive: [{
                    breakpoint: 750,
                    settings: {
                        dots: false
                    }
                }],
                customPaging: function (slider, i) {
                    return $('<button type="button" />');
                },
            });

            checkMobileHeights();
        }
        else
        {
            // On init
            $(gallery).on('init', function (event, slick) {
                var currentSlide = $(gallery).find('.slick-current');
                var prevSlide = $(currentSlide).prev();
                var prevElem = $(prevSlide).find('li');
                $(prevElem).css('paddingRight', '18px');
                $(prevElem).css('opacity', '0.5');

                var nextSlide = $(currentSlide).next();
                var nextElem = $(nextSlide).find('li');
                $(nextElem).css('paddingLeft', '18px');
                $(nextElem).css('opacity', '0.5');

                $(prevElem).click(function () {
                    $('.sliderPrev').trigger('click');
                });
                $(nextElem).click(function () {
                    $('.sliderNext').trigger('click');
                });

                $('ul.slick-dots').children().each(function (k, v) {
                    if (k >= 5) {
                        $(this).remove();
                    }
                })
            });

            $(gallery).slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                fade: false,
                prevArrow: ".sliderPrev",
                nextArrow: ".sliderNext",
                centerMode: true,
                centerPadding: '14vw',
                dots: true,
                appendDots: '.block.gallery-block',
                responsive: [
                    {
                        breakpoint: 900,
                        settings: {
                            centerPadding: '5vw'
                        }
                    },
                    {
                        breakpoint: 750,
                        settings: {
                            dots: false,
                            centerPadding: '0vw'
                        }
                    },
                ],
                customPaging: function (slider, i) {
                    return $('<button type="button" />');
                }
            });
            $(gallery).on('breakpoint', function (event, slick, breakpoint) {
                $('ul.slick-dots').children().each(function (k, v) {
                    if (k >= 5) {
                        $(this).remove();
                    }
                });

            });

            // On before slide change
            $(gallery).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                var currentSlide = $(gallery).find('.slick-current');
                var prevSlide = $(currentSlide).prev();
                var prevElem = $(prevSlide).find('li');
                $(prevElem).css('paddingRight', '0px');
                $(prevElem).css('opacity', '1');

                var nextSlide = $(currentSlide).next();
                var nextElem = $(nextSlide).find('li');
                $(nextElem).css('paddingLeft', '0px');
                $(nextElem).css('opacity', '1');

                $(prevElem).unbind('click');
                $(nextElem).unbind('click');
            });

            // On after slide change
            $(gallery).on('afterChange', function (event, slick, currentSlide) {

                var currentSlide = $(gallery).find('.slick-current');
                var prevSlide = $(currentSlide).prev();
                var prevElem = $(prevSlide).find('li');
                $(prevElem).css('paddingRight', '18px');
                $(prevElem).css('opacity', '0.5');

                var nextSlide = $(currentSlide).next();
                var nextElem = $(nextSlide).find('li');
                $(nextElem).css('paddingLeft', '18px');
                $(nextElem).css('opacity', '0.5');

                $(prevElem).click(function () {
                    $('.sliderPrev').trigger('click');
                });
                $(nextElem).click(function () {
                    $('.sliderNext').trigger('click');
                });
            });


            $('.menu-btn-premium').click(function () {
                $('.main-nav').toggleClass('active');
                $('#menu-main-menu').toggleClass('active');
                $(this).toggleClass('open');
            });
        }
    }

    $('.menu-btn').click(function() {
        $('.main-nav').addClass('active');
        $('#menu-main-menu').addClass('active');
    });

    $('.close-menu').click(function() {
        $('.main-nav').removeClass('active');
        $('#menu-main-menu').removeClass('active');
    });

    $('.menu-item-has-children').click(function() {
        $(this).children('.dropdown').toggleClass('active');
        $(this).children('.sub-menu').toggleClass('active');
        $(this).toggleClass('active');
    });

    $('.filter-head').click(function() {
        $(this).toggleClass('active');
        $('.search-bar').toggleClass('active');
        $('.category-filters').toggleClass('active');
    });

    $(window).bind('hashchange', function() {
        var hash = document.location.hash;
        var hash = hash.replace('#', '');
        if (hash == "book-a-table") {
           $(".table-iframe").trigger("click");
        }
    });
    window.onload = function() {
        var hash = (window.location.hash).replace('#', '');
        if (hash == "book-a-table") {
            $(".table-iframe").trigger("click");
        }
    }
    if (location.href.indexOf("#") != -1) {
            var hash = window.location.hash.substring(1);
            var hash = hash.replace('#', '');
            if (hash == "book-a-table") {
               $(".table-iframe").trigger("click");
            }
    }
    $(document).on("click",'a[href="#book-a-table"]',function(e) {
        e.preventDefault();
        $(".table-iframe").trigger("click");
    });

    if (typeof window.location.search.substr(1) != "undefined") {
        if (window.location.search.substr(1) === "book-a-table") {
            $('#table-book-old').addClass('active');
        }
    }

    $('.close-iframe').click(function() {
        $('.table-book-wrap').removeClass('active');
    });

    $('.close-popup').click(function() {
        $('.popup-wrap').removeClass('enable-popup');
    });

    let scrollTop = 0;
    if(!$('body').hasClass('prestige')) {
        let SCROLL_THRESHOLD = 30;
        $(window).scroll(function () {
            scrollTop = $(window).scrollTop();
            // $('.counter').html(scrollTop);

            if (scrollTop >= SCROLL_THRESHOLD) {
                $('.page-head').addClass('scrolled-nav');
            } else if (scrollTop < SCROLL_THRESHOLD) {
                $('.page-head').removeClass('scrolled-nav');
            }
        });
    }
    else{
        let SCROLL_THRESHOLD = 1;
        $(window).scroll(function () {
            scrollTop = $(window).scrollTop();

            if (scrollTop >= SCROLL_THRESHOLD) {
                $('.page-head').addClass('scrolled-nav');
            } else if (scrollTop < SCROLL_THRESHOLD) {
                $('.page-head').removeClass('scrolled-nav');
            }

            //-- enable reveal effect only for desktop
            if(window.innerWidth > MOBILE_WIDTH_TRESHOLD){
                reveal();
            }
        });
        scrollTop = $(window).scrollTop();

        if (scrollTop >= SCROLL_THRESHOLD) {
            $('.page-head').addClass('scrolled-nav');
        } else if (scrollTop < SCROLL_THRESHOLD) {
            $('.page-head').removeClass('scrolled-nav');
        }
        $('.flexible-content-wrap-premium.prestige').children().eq(1).find('.reveal').each((k,v) =>{
            $(v).removeClass('reveal');
        });

        //-- enable reveal effect only for desktop
        if(window.innerWidth > MOBILE_WIDTH_TRESHOLD){
            reveal();
        }

    }
    $('.hero-book').click(function() {
        $('.hero-popup').addClass('active');
    });

    $('.form-close').click(function() {
        $('.hero-popup').removeClass('active');
    });

    if($('body').hasClass('premium')) {
        if(!$('body').hasClass('prestige')) {
            checkTop();
        }

        $('.faqs .list-element').click(function(e){
            $(this).toggleClass('open');
        });

        $('.book-bar input[type="text"]').each(function(k,v){
            $(v).datepicker({ dateFormat: 'dd/mm/yy' });
        });

        if($('.book-bar form').length){

            $('.book-bar form').each(function(){
                $(this).submit(function(e){

                    if($(this).find('input[name="dateFrom"]').val() && $(this).find('input[name="dateTo"]').val()){

                        var arrival = convertUKDateStringToUSDateString($(this).find('input[name="dateFrom"]').val())
                        var departure = convertUKDateStringToUSDateString($(this).find('input[name="dateTo"]').val())
                        var date1 = new Date(arrival);
                        var date2 = new Date(departure);

                        // To calculate the time difference of two dates
                        var Difference_In_Time = date2.getTime() - date1.getTime();

                        // To calculate the no. of days between two dates
                        var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);

                        $(this).find('input[name="numNights"]').val(Difference_In_Days);

                    } else {
                        $(this).append('<div class="alert alert--error">Please enter dates in the format dd/mm/yyyy</div>');
                        e.preventDefault();
                    }
                });
            });
        }

        if($('.vimeo').length > 0){
            checkVimeo();
        }
    }

    $('button[name="add-to-cart"]').on('click', function(){
        fbq('track', 'AddToCart');
    });

    $('a.checkout-button').on('click', function(){
        fbq('track', 'InitiateCheckout');
    });

    $('.mobile-carousel').each((k, v) => {
        $(v).slick({
            arrows: false,
            dots: false,
            infinite: true,
            autoplay: true,
            cssEase: 'linear',
            speed: 2000,
            autoplaySpeed: 5000,
            pauseOnHover: false,
            pauseOnFocus: false,
            adaptiveHeight: false,
            fade: true
        });
    });

    $('.opening_hours_footer').click((e)=>{
        let el = e.target;
        if(!$(el).hasClass('opening_hours_footer')){
            el = $(el).closest('.opening_hours_footer');
        }
        $(el).parent().toggleClass('active');
        let min_h = 0;
        $(el).parent().children().each((k,v) => {
            min_h += $(v).outerHeight();
        })
        if($(el).parent().hasClass('active')) {
            $(el).parent().height(min_h);
        }else{
            $(el).parent().height('49px');
        }
    });

    $('.ginput_container_consent').each((k,v) => {
        $(v).find('input[type="checkbox"]').trigger('click');
    });

    $('.global-floating-cta-form .form-close-btn, .global-floating-cta-form .form-open-btn').on('click', function(){
        $('.global-floating-cta-form').toggleClass('active');
    });

    $('.custom-anchor-tag').off('click');
    $('.custom-anchor-tag').on('click', function()
    {
        if($(this).hasClass('custom-table-iframe'))
        {
            $(".table-iframe").trigger("click");
        }
        else
        {
            var _href = $(this).data('href');
            if(_href != '' && _href != undefined){
                location.href = _href;
            }
        }
        return false;
    });

    if($('.attractions-prestige.prestige').length > 0)
    {
        var _attractions_match_height = function()
        {
            let _block_names = [];
            _block_names.push('attractions-prestige');

            $.each(_block_names, function( index, value ) {
                $('.' + value).each(function(){
                    let _this = this;
                    let cardwrapper = $(_this).find('.content-wrapper');
                    cardwrapper.sameHeight();
                });
            });
        };
        _attractions_match_height();

        $(window).on('resize', function(){
            _attractions_match_height();
        });
    }
});

function checkMobileHeights(){
    let myResizeCallback = function(){
        $('.mobile_check_height').each((k, v) => {
            let card = $(v).find('.card-wrapper-prestige');
            let H = $(card).outerHeight();
            let top = parseInt($(card).css('top'));
            let tot = H + top;
            $(v).height(tot);
        });
        reveal();
    };
    if(window.innerWidth < MOBILE_WIDTH_TRESHOLD) {
        setTimeout(myResizeCallback, 2000);
    }else{
        document.querySelectorAll('.mobile_check_height').forEach((v) => {
            v.style.removeProperty('height');
        });
    }
}

$(window).resize(function() {
    if(!$('body').hasClass('prestige')) {
        checkTop();
    }

//    fixGalleryTabs();
    if($('.vimeo').length > 0){
        checkVimeo();
    }
    checkMobileHeights();
});

function checkVimeo(){
    var ratio = $('.vimeo').parent().data('ratio');
    var wrapper = $('.vimeo').parent().parent();
    var W = $(wrapper).width();
    var estH = Math.round(W * (1/ratio));
    $(wrapper).height(estH);
}

function fixGalleryTabs(){
    $('.gallery-block .slick-dots').children().gt(4).each(function(k,v){
        $(v).remove();
    });
}

function checkTop(){
    var H = Math.floor($('header.page-head').outerHeight() - 1);
    $('.flexible-content-wrap-premium').css('paddingTop', H+'px');

    var W = $(window).width();
    var calc;
    if(W <= 750){
        calc = 'calc(50vh - '+H+'px)';
    }else{
        calc = 'calc(100vh - '+H+'px)';
    }
    $('.hero-block-wrapper img').css('height', calc);
    $('.hero-block-wrapper .videowrapper').css('height', calc);
    $('.hero-block-wrapper .videoplayer').css('height', calc);
    $('.hero-block-wrapper .overlay-wrapper').css('height', calc);

}

function convertUKDateStringToUSDateString(date){

    var dateParts = date.split("/");

    var dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);

    return dateObject.toString();
}

if($('.hero-book').length > 0) {
    var fixmeTop = $('.hero-book').offset().top - $("header.page-head").height(); // get initial position of the element
    $(window).scroll(function () {
        var currentScroll = $(window).scrollTop();

        if (currentScroll >= fixmeTop) {
            if($('#hero-book-clone').length == 0) {
                let clone = $('.hero-book').clone(true, true).attr('id', 'hero-book-clone');
                $('body').append(clone);
                $('body').addClass('book-direct-mobile');
            }
        } else {
            $('.hero-book').removeAttr("style");
            $('#hero-book-clone').remove();
            $('body').removeClass('book-direct-mobile');
        }

    });
}

function showMenu() {
    $('.menu-overlay').addClass('active');
    $('.menu-btn-close').addClass('active');
}
function hideMenu() {
    $('.menu-overlay').removeClass('active');
    $('.menu-btn-close').removeClass('active');
}

function scrollNext(el){
    let curRef = $(el).data('ref');
    if(typeof curRef === 'undefined'){
        const dest = $(el).closest('.hero-block-prestige-hp-wrapper').next();
        const curID = $(dest).attr('id');
        if(typeof curID === 'undefined'){
            const newId = "id-"+Math.floor(Math.random() * 999);
            $(dest).attr('id', newId);
            curRef = '#'+newId;
            $(el).data('ref', curRef);
        }else{
            curRef = '#'+curID;
            $(el).data('ref', curRef);
        }
    }
    $('html, body').animate({
        scrollTop: $(curRef).offset().top - 143
    }, 800, function(){
        // Add hash (#) to URL when done scrolling (default click behavior)
        // window.location.hash = curRef;
    });
}

function reveal() {
    var reveals = document.querySelectorAll(".reveal");
    for (var i = 0; i < reveals.length; i++) {
        var windowHeight = window.innerHeight;
        var elementTop = reveals[i].getBoundingClientRect().top;
        var elementVisible = 50;
        if (elementTop < windowHeight - elementVisible) {
            reveals[i].classList.add("active");
        } else {
            reveals[i].classList.remove("active");
        }
    }
}

if(typeof gform !== "undefined") {
    gform.addFilter('gform_datepicker_options_pre_init', function (optionsObj, formId, fieldId) {

        // Apply to field 2 only
        if (fieldId == 5) {
            optionsObj.minDate = 0;
        }
        return optionsObj;
    });
}